export default __webpack_public_path__ + "static/media/item_2.fbd48b08.webp";